import { RouteDataInterface } from '@modules/map/interfaces/route-data.interface';

import { TestRouteModel } from './test-route.model';

export class TestRouteCollectionModel {
  public day: number;
  private _routes: TestRouteModel[] = [];

  public routesData: RouteDataInterface[] = [];

  constructor(day: number) {
    this.day = day;
  }

  addRoute(route: TestRouteModel) {
    this._routes.push(route);
    this.routesData = this._routes.map((route) => {
      return {
        route,
        color: route.color,
        cords: route.cords,
      };
    });
  }

  get routes() {
    return this._routes;
  }
}
